var _rect, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 60",
    width: 240,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 60,
    fill: "transparent"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 32,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 15,
    fontWeight: "bold",
    fill: "#1e293b",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "Govt. of Telangana")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner2);
export default __webpack_public_path__ + "static/media/partner2.b30d52af6322bb195c5e9304f9d75fad.svg";
export { ForwardRef as ReactComponent };